var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42859 1C3.67159 1 1.42859 3.243 1.42859 6C1.42859 8.757 3.67159 11 6.42859 11C9.18559 11 11.4286 8.757 11.4286 6C11.4286 3.243 9.18559 1 6.42859 1ZM6.42859 10C4.22309 10 2.42859 8.2055 2.42859 6C2.42859 3.7945 4.22309 2 6.42859 2C8.63409 2 10.4286 3.7945 10.4286 6C10.4286 8.2055 8.63409 10 6.42859 10Z",
    fill: "#808297"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92859 5.5H6.92859V8.5H5.92859V5.5ZM5.92859 3.5H6.92859V4.5H5.92859V3.5Z",
    fill: "#808297"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.75aae2fa8b616d2bfc5b76a215ee4fb5.svg";
export { ForwardRef as ReactComponent };